export const useIIFE = <T>(fn: () => T) => {
  return fn();
};
